<template>
    <b-modal id="editModal" ref="modal" title="Edit Processor" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Processor Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="update.name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!processor.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="processor.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteProcessorMutation from '@views/Processors/EditModal/mutationDeleteProcessor.graphql';
import restoreProcessorMutation from '@views/Processors/EditModal/mutationRestoreProcessor.graphql';
import updateProcessorMutation from '@views/Processors/EditModal/mutationUpdateProcessor.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    processor: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      update: {
        name: this.processor.name,
      },
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.update.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateProcessorMutation,
            variables: {
              input: {
                id: this.processor.id,
                name: this.update.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateProcessor: {
                ...this.processor,
                ...this.update
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Processor updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteProcessorMutation,
          variables: {
            input: {
              id: this.processor.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            deleteProcessor: {
              ...this.processor,
              deleted_at: '1970-01-01 00:00:00',
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Processor disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreProcessorMutation,
          variables: {
            input: {
              id: this.processor.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreProcessor: {
              ...this.processor,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Processor restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
